import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#FF0054", // Lsnto Pink
    },
    secondary: {
      main: "#E4FF1A", // Lsnto Yellow
    },
    background: {
      default: "transparent", // We'll handle gradient in CSS
      paper: "#1b1324",
    },
    text: {
      primary: "#ffffff",
      secondary: "#E4FF1A",
    },
    error: {
      main: "#FF0000",
    },
    success: {
      main: "#4CAF50",
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.2rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "1.8rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          fontWeight: 600,
          padding: "10px 16px",
          backgroundColor: "#FF0054",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#D40045",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          color: "#000000",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "FFE4FF1A",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FF0054",
          },
        },
        input: {
          color: "#000000",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#000000",
          "&.Mui-focused": {
            color: "#FF0054",
          },
          transform: "translate(14px, 12px) scale(1)",
          "&.MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
          }
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#1b1324",
          color: "#ffffff",
          borderRadius: "12px",
          padding: "16px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.5)",
        },
      },
    },

    // ✅ ADDED: Force white slider thumb
    MuiSlider: {
      styleOverrides: {
        thumb: {
          backgroundColor: "#ffffff",
          border: "2px solid rgba(255, 255, 255, 0.6)",
          boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.5)",
          height: 14,
          width: 14,
        },
        track: {
          backgroundColor: "#FF0054",
        },
        rail: {
          backgroundColor: "#ffffff",
          opacity: 0.3,
        },
      },
    },
  },
});

export default theme;
